import React from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'

const DeleteModal = ({ processDelete, isOpen , handleClose}) => {
    const handleDelete = () => {
        processDelete();
        handleClose();
    }

    return (
        <ReactModal
            className={'confirmation-modal'}
            overlayClassName={'confirmation-modal-overlay'}
            contentLabel= {'Delete Confirmation'}
            onRequestClose={handleClose}
            isOpen={isOpen}>

            <div className={'confirmation-modal-content'}>

                <div className={'confirmation-modal-header'}>
                    <button type={'button'} className={'close confirmation-modal-button'} style={{'paddingRight': '10px'}} onClick={handleClose} >&times;</button>
                    <div className={'confirmation-modal-title'}>
                            Delete
                    </div>
                </div>

                <div className={'confirmation-modal-body'}>
                    <div className={'confirmation-modal-text'}>
                        Are you sure you want to proceed?
                    </div>
                </div>

                <div className={'confirmation-modal-footer'}>
                    <button type={'button'} className={'btn btn-default'} style={{ 'marginRight': '10px'}} onClick={handleClose}>Close</button>
                    <button type={'button'} className={'btn btn-danger'} onClick={handleDelete}>Delete</button>
                </div>
            </div>

        </ReactModal>
    )
}

DeleteModal.propTypes = {
    processDelete: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
}

export default DeleteModal



// WEBPACK FOOTER //
// ./src/modules/customer/component/image/DeleteModal.js